import {Machine} from '@/core/machine.js';

new Machine();
